import { $closest, $data, $hasClass, $qs } from 'fxdom/es';
import { delay, go, pick } from 'fxjs/es';
import { NessCustomMakerF } from '../../../../F/Function/module/NessCustomMakerF.js';
import { NessCustomMakerCoreF } from '../../../../Core/F/Function/module/NessCustomMakerCoreF.js';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { fcanvasChanging } from '../../../../../Maker/F/util.js';
import { errorHandlingEventWrapper } from '../../../../../NewMaker/Error/F/Function/errorHandlingEventWrapper.js';
import { changeProductColorByBpc, changeProductColorByBps } from '../../../../../Maker/F/mp_maker.js';
import { BpOptionF } from '../../../../../BpOption/F/Function/module/BpOptionF.js';
import { makeProductColorWithThumbnailTodataurlByBpcOrBpId } from '../../../../../Composite/Thumbnail/F/fs.js';

// 값만 바꾸는지, 메이커의 상태도 바꾸는지 구별
const is_maker = () => !!box.sel('maker->editing_canvas');

const handleSelectableEvent = (e, callback) => {
  return fcanvasChanging(
    errorHandlingEventWrapper(async function (e) {
      return _p.go(e, $.selectable, $data, async function (data) {
        $.don_loader_start();
        await delay(10, () => {});
        const scroll_wrapper_el = $.closest(e.$currentTarget, '.iscroll_wrapper');
        $.iscroll_to(scroll_wrapper_el, e.currentTarget);

        await callback(data);

        if (is_maker()) NessCustomMakerF.refreshCustomProductDetailHead();
        $.don_loader_end();

        const is_editing_mode = $hasClass('maker_editor_mode', $1('html'));
        if (!is_editing_mode) MuiF.closeFrame();
      });
    }),
  )(e);
};

export const bpColorSelectEvent = (e) => {
  return handleSelectableEvent(e, async (bpc) => {
    if (is_maker()) await NessCustomMakerCoreF.changeProductBaseProductColor(bpc);
    else {
      await changeProductColorByBpc(bpc);
      box().maker.product_color = await go(
        makeProductColorWithThumbnailTodataurlByBpcOrBpId({
          product_color: box().maker.product_color,
          // product_color: Object.assign(box().maker.product_color, { product_faces2 }),
          bpc_id: bpc.id,
        }),
        pick([
          'base_product_color_id',
          'base_product_id',
          'base_product_size_id',
          'product_faces2',
          'price_info',
          'thumbnails',
        ]),
        (obj) => Object.assign({}, box().maker.product_color, obj),
      );
    }
  });
};

export const bpDeviceSelectEvent = (e) => {
  return handleSelectableEvent(e, async (bp) => {
    if (is_maker()) await NessCustomMakerCoreF.changePhoneCaseBpByBpId(bp.id);
    else {
      // device ...
    }
  });
};

export const bpSizeSelectEvent = (e) => {
  return handleSelectableEvent(e, async (base_product_size) => {
    if (is_maker()) await NessCustomMakerCoreF.changeProductBaseProductSize(Number(base_product_size.id));
    else changeProductColorByBps({ id: base_product_size.id });
  });
};

export const bpOptionSelectEvent = (e) => {
  return handleSelectableEvent(e, async (bp) => {
    const selectElement = $qs(`select[name="${e.currentTarget.getAttribute('name')}"]`);
    if (selectElement) {
      if (is_maker()) await NessCustomMakerCoreF.bpSelectOptionHandling(selectElement, bp.id);
      else {
        const bp_option_group_el = $closest('.bp_option_group')(selectElement);
        BpOptionF.selectBpOption({ bp_option_group_el, selected_bp_option_id: bp.id });

        const bp_option_groups_el = $closest('.bp_option_groups')(bp_option_group_el);
        const selected_option_group = BpOptionF.makeSelectedOptionGroup(bp_option_groups_el);
        box().maker.product_color._.selected_option_group = selected_option_group;
      }
    }
  });
};
